export default "__VITE_ASSET__veAzq_qu__"